export const getSubmodelDisplayName = (
  vehicleModelName: null | string,
  submodelName: null | string
): string => {
  if (!vehicleModelName) {
    return submodelName ?? "";
  }
  const displaySubmodelName =
    submodelName?.replace(vehicleModelName, "").trim() ?? "";
  if (displaySubmodelName.length > 1) {
    return displaySubmodelName;
  }
  return submodelName ?? "";
};
